import { TableTemplate } from 'types/tableTemplate';

export const accessRulesTableTemplate: TableTemplate[] = [
  { id: 'name', description: 'NOME', originalId: 'name', width: 400 },
  { id: 'title', description: 'TÍTULO', originalId: 'title', width: 400 },
  { id: 'description', description: 'DESCRIÇÃO', originalId: 'description', width: 500 },
];
